<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-plant type="search" name="plantCd" v-model="searchParam.plantCd" />
        </div>
        <div v-if="this.$route.meta.params.ramTechniqueCd === 'RT00000040'" class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="JOB_CATEGORY_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            label="직군"
            name="jobCategoryCd"
            v-model="searchParam.jobCategoryCd"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            v-if="this.$route.meta.params.ramTechniqueCd === 'RT00000040'"
            :comboItems="flagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            label="진행상태"
            name="officeCompleteFlag"
            v-model="searchParam.officeCompleteFlag"
          />
          <c-select
            v-else
            :comboItems="stepItems"
            type="search"
            itemText="stepperMstNm"
            itemValue="stepperMstCd"
            name="ramStepCd"
            label="진행상태"
            v-model="searchParam.ramStepCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            codeGroupCd="RAM_ASSESS_TYPE_CD"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="ramAssessTypeCd"
            label="평가구분"
            v-model="searchParam.ramAssessTypeCd"
          ></c-select>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-dept
            type="search"
            label="평가부서"
            :isFirstValue="false"
            name="deptCd"
            v-model="searchParam.deptCd"
          ></c-dept>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            defaultStart="-1y"
            LBL0000607="1M"
            label="평가기간"
            name="assessmentDates"
            v-model="searchParam.assessmentDates"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      title="위험성평가 목록"
      :columns="grid.columns"
      :data="grid.data"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template slot="table-button">
        <q-btn-group outline>
          <c-btn
            v-if="editable && !searchParam.isVendor"
            label="등록"
            icon="add_circle"
            @btnClicked="addRisk"
          />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import selectConfig from "@/js/selectConfig";
export default {
  name: "riskList",
  data() {
    return {
      searchParam: {
        plantCd: null,
        assessmentDates: [],
        ramAssessTypeCd: null,
        ramStepCd: null,
        officeCompleteFlag: null,
        ramTechniqueCd: "",
        isVendor: false,
        approvalUserId: "",
        deptCd: null,
        jobCategoryCd: null
      },
      grid: {
        columns: [
          {
            name: "plantName",
            field: "plantName",
            label: "LBLPLANT",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "assessmentName",
            field: "assessmentName",
            // 평가명
            label: "LBL0000367",
            align: "left",
            style: "width:250px",
            sortable: true,
            type: "link",
          },
          {
            name: "ramStepName",
            field: "ramStepName",
            label: "진행상태",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "approvalStatusName",
            field: "approvalStatusName",
            label: "결재진행단계",
            align: "center",
            sortable: true,
            style: "width:100px",
          },
          {
            name: "assessmentDate",
            field: "assessmentDate",
            label: "평가기간",
            align: "center",
            style: "width:150px",
            sortable: true,
          },
          {
            name: "ramAssessTypeName",
            field: "ramAssessTypeName",
            label: "평가구분",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
          {
            name: "deptName",
            field: "deptName",
            label: "평가부서",
            align: "center",
            style:
              this.$route.meta.params.ramTechniqueCd === "RT00000040"
                ? "width:200px"
                : "width:100px",
            sortable: true,
          },
          {
            name: "regUserName",
            field: "regUserName",
            label: "작성자",
            align: "center",
            style: "width:100px",
            sortable: true,
          },
        ],
        data: [],
      },
      stepItems: [],
      flagItems: [
        { code: "Y", codeName: "완료" },
        { code: "N", codeName: "작성중" },
      ],
      editable: true,
      listUrl: "",
      popupOptions: {
        isFull: true,
        target: null,
        title: "",
        visible: false,
        top: "",
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {},
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.ram.assessPlan.list.url;
      // code setting
      this.$comm.getStepItems("RAM_RISK_STEP_CD").then((_result) => {
        _result.splice(1, 1);
        this.stepItems = _result;
      });
      this.$set(
        this.searchParam,
        "ramTechniqueCd",
        this.$route.meta.params.ramTechniqueCd,
      );
      if (this.$route.meta.params.approvalUserId) {
        this.$set(
          this.searchParam,
          "approvalUserId",
          this.$store.getters.user.userId,
        );
        this.$set(this.searchParam, "isVendor", true);
      }
      if (this.$route.meta.params.ramTechniqueCd === "RT00000040") {
        this.grid.columns.splice(2, 0, {
          name: 'jobCategoryName',
          field: 'jobCategoryName',
          label: '대상직군',
          align: "center",
          style: "width:80px",
          sortable: true,
        });
      }
      // list setting
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = "GET";
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      });
    },
    /* eslint-disable no-unused-vars */
    addRisk() {
      this.linkClick();
    },
    linkClick(row) {
      this.popupOptions.title = "위험성평가 상세";
      this.popupOptions.param = {
        ramRiskAssessmentPlanId: row ? row.ramRiskAssessmentPlanId : "",
        ramStepCd: row ? row.ramStepCd : "RRS0000001",
        officeCompleteFlag: row ? row.officeCompleteFlag : "N",
        vendorFlag: row ? row.vendorFlag > 0 : false,
        ramTechniqueCd: this.$route.meta.params.ramTechniqueCd,
      };
      this.popupOptions.target = () => import(`${"./riskDetail.vue"}`);
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      this.getList();
    },
  },
};
</script>
